import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Constants } from '@app/constants';
import { AuthenticationService } from '@app/core';
import { BehaviorSubject, Subject, Subscription, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { TelephonyProvider } from '../providers/telephony/telephony.provider';
import { TelephonyStateService } from '../providers/telephony/telephony.state.service';
import { CheckPermission, momentCustomInstance as moment } from '@projects/shared/src/app/utils/helper';
import { CampaignService } from './campaign.service';
import { summariesReports } from '../features/insight/summaries/summaries.routes';
import { UserService } from '@projects/admin/src/app/services/user.service';
const SideNavMapping: any = { left: 'leftSideNav', right: 'rightSideNav' };
export enum _RightSideNavRoutes {
  DIALPAD,
  INFO,
  VERBIAGE,
  NOTE,
}
export enum _TranscriptDetailTab {
  DETAIL,
  HISTORY,
  ADVANCEINFO,
  ADVANCEHISTORY,
}

export enum InsightsDashboardTab {
  Voice,
  Assistant,
}

@Injectable({
  providedIn: 'root',
})
export class NavService implements OnDestroy {
  public KEYPADS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];
  public dialScreenText = '+17053005608';
  public RightSideNavRoutes = _RightSideNavRoutes;
  public TranscriptDetailTab = _TranscriptDetailTab;
  // public isInsight = new BehaviorSubject<boolean>(false);
  private currentRoute = '';
  private title = 'Dashboard';
  private unreadNotificationCount = 0;
  private notificationPane = false;
  private requestPane = false;
  private leftSideNav = false;
  private rightSideNav = false;
  private callContext = false;
  private profileContext = false;
  private rightSideRoute = _RightSideNavRoutes.DIALPAD;
  private transcriptDetailTab = _TranscriptDetailTab.DETAIL;
  private subscriptions = Array<Subscription>();
  private bugReportPane = false;
  isShowRightDrawer = false;
  isTimeZoneModalOpen: boolean = false;
  showCenterLocation: boolean = false
  showGridSettings: boolean = false
  checkPermission = CheckPermission;
  public topNavs: any[] = [
    {
      name: 'ConnectHub',
      url: '/agent/dashboard',
      active: false,
      // show: this.checkPermission('agent', 'agent_dashboard', this.authService),
      show: false,
    },
    {
      name: 'Sightline',
      url: '/supervisor/insight/dashboard',
      active: false,
      // show: this.checkPermission('insights', 'insights_dashboard', this.authService),
      show: false,
    },
    {
      name: 'Backstage',
      url: '/admin/user/list',
      active: false,
      // show: this.checkPermission('admin', '', this.authService),
      show: false,
    },
  ];
  public sideNavs: any[] = [];

  // tabs
  InsightsDashboardTab = InsightsDashboardTab;
  InsightsDashboardTabChange = new BehaviorSubject<boolean>(false);
  tabs = [
    {
      id: InsightsDashboardTab.Voice,
      name: 'Voice',
      enabled: true,
      isActive: true,
      show: this.checkPermission('insights', 'insights_dashboard', this.authService), 
    },
    {
      id: InsightsDashboardTab.Assistant,
      name: 'Assistant',
      enabled: true,
      isActive: false,
      show: this.checkPermission('insights_chat', 'insights_chat_dashboard', this.authService),
    },
  ];
  selectedTab = this.tabs.find((tab) => tab.isActive)!.id;
  onCenterChangeEvent$ = new Subject<any>();
  centerData: any = {};
  isCenterLocation: boolean = true;
  isBusinessHoursIcon: boolean = true;
  onCenterTabChangeEvent$ = new Subject<{ center: string; isTabSelection: boolean }>();
  onAgentsViewToStatusMonitorEvent$ = new Subject<{ agentKey: number; }>();
  todayScheduledCallbacks = {
    isSidePanelOpen: false,
    apiItems: [] as Array<any>,
    localItems: [] as Array<{
      id: string;
      time: string;
    }>,
    scheduledCallCount:0,
    isConnectHubScreen:true,
    isReload$: new Subject<boolean>()
  }
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
    private campaignService: CampaignService,
    private telephony: TelephonyProvider,
    private telephonyState: TelephonyStateService,
    private userService: UserService 
  ) {
    
    //* Load Default Nav
    this.defaultSideNav();
    this.subscriptions.push(
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.currentRoute = this.router.url;
          let config: any = this.router.config;
          const segments = this.router.url.split('/').filter((x: string) => !['', '/'].includes(x));
          segments.forEach((segment: string, index: number) => {
            //* For Query Params We Need
            //* TO Exclude The Query
            let seg = this.canSplit(segment, '?') ? segment.split('?')[0] : segment;
            if (Array.isArray(config))
              config = config.find((x: any) => x.path === seg || '/' + seg === x.path || x.path.split('/')[0] === seg);
            if (config && config._loadedRoutes && config._loadedRoutes.length > 0 && index + 1 < segments.length) {
              for (const loadedRoute of config._loadedRoutes) {
                if (loadedRoute && loadedRoute.children) {
                  config = loadedRoute.children;
                  break;
                }
              }
            } else {
              let title = config?.data?.title || '';
              //* Code For multi Roles Used Route -- uncomment if have to used and uncoment form route
              // if (config?.data?.multiRoleRouteUsed) {
              //   const agentPath = event.url.toLocaleLowerCase().search(/agent/g) > -1;
              //   const supervisorPath = event.url.toLocaleLowerCase().search(/supervisor/g) > -1;
              //   if (agentPath) title = config?.data?.agentTitle;
              //   else title = config?.data?.supTitle;
              // }
              if (title === 'Campaign' && this.campaignService.campaignName) {
                this.campaignService.campaignName?.subscribe((campaignName: string) => {
                  this.setTitle(campaignName);
                });
              } else {
                this.setTitle(title);
              }
            }
          });
        }
      })
    );
    this.subscriptions.push(
      this.telephony.voice.events.subscribe((event: any) => {
        switch (event.type) {
          case 'Call':
            switch (event.name) {
              case 'accept':
                this.rightSideNav = false;
                break;
              case 'dispose':
                this.rightSideRoute = _RightSideNavRoutes.DIALPAD;
                break;
            }
            break;
          case 'Activity':
            switch (event.name) {
              case 'update':
                if (event.data.activity === Constants.STATUSES.ManualCall.FriendlyName) {
                  this.rightSideNav = true;
                } else {
                  if (!this.telephonyState.onCall) this.rightSideNav = false;
                }
                break;
            }
            break;
        }
      })
    );
    this.subscriptions.push(
      this.onCenterChangeEvent$.subscribe((data) => {
        this.centerData = data;
      })
    );

    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        const agentPath = event.url.toLocaleLowerCase().includes('/agent/');
        const insightPath = event.url.toLocaleLowerCase().includes('/insight/');
        const adminPath = event.url.toLocaleLowerCase().includes('/admin/');
        if (agentPath) {
          this.setTopNavBarSelect({ name: 'ConnectHub' });
        } else if (insightPath) {
          this.setTopNavBarSelect({ name: 'Sightline' });
        } else if (adminPath) {
          this.setTopNavBarSelect({ name: 'Backstage' });
        }
      }
    });

    // if (this.router.url.includes('insight')) {
    //   // this.topNavs[0].active = false;
    //   // this.topNavs[1].active = true;
    //   this.topNavs.map((d, i) => {
    //     if (d.name === 'Insights') d.active = true;
    //     else d.active = false;
    //   });
    // }
    this.authService.QADefaultUrl();
    this.topNavs = [
      {
        name: 'ConnectHub',
        url: Constants.Apps.Agent.defaultPath,
        active: false,
        show: false,
      },
      {
        name: 'Sightline',
        url: Constants.Apps.Supervisor.defaultPath,
        active: false,
        show: false,
      },
      {
        name: 'Backstage',
        url: Constants.Apps.Admin.defaultPath,
        active: false,
        show: false,
      },
    ];
    this.topNavs = this.topNavs.map(nav => ({
      ...nav,
      show: this.authService.authData.AssignedApp.includes(nav.name),
      active: nav.name === this.authService.authData.PrimaryApp
    }));
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  public setTopNavBarSelect(selectedNav: any) {
    this.topNavs.map((d, i) => {
      if (d.name === selectedNav.name) d.active = true;
      else d.active = false;
    });
  }

  public defaultSideNav() {
    // this.isInsight.next(false);
    this.sideNavs = [
      {
        name: 'Home',
        url: '/agent/dashboard',
        icon: 'fa-thin fa-gauge',
        opened: false,
        show: this.checkPermission('agent', 'agent_dashboard', this.authService),
      },
      {
        name: 'Calls',
        opened: false,
        url: '/agent/calls/campaign',
        icon: 'fa-thin fa-phone',
        children: [
          {
            name: 'Campaign',
            url: '/agent/calls/campaign',
            icon: 'fa-solid fa-chart-line',
            show: this.checkPermission('agent_calls', 'agent_calls_campaign', this.authService),
          },
          {
            name: 'Call Back',
            url: '/agent/summaries/callback',
            icon: 'fa-solid fa-headset',
            show: this.checkPermission('agent_calls', 'agent_calls_callBack', this.authService),
          },
          {
            name: 'Call Logs',
            url: '/agent/summaries/callLog',
            icon: 'fa-solid fa-clock-rotate-left',
            show: this.checkPermission('agent_calls', 'agent_calls_callBack', this.authService),
          },
          {
            name: 'Leads',
            url: '/agent/summaries/leads',
            icon: 'fa-solid fa-phone-arrow-right',
            isQueryParams: true,
            querParams: { assignedLeads: true },
            show: this.checkPermission('agent_calls', 'agent_calls_leads', this.authService),
          },
          {
            name: 'Meeting Schedular',
            url: '/agent/calls/lead-schedular',
            icon: 'fa-solid fa-calendar-clock',
            show: this.checkPermission('agent_calls', 'agent_statistics_meetingSchedular', this.authService),
          },
          // { name: 'Missed Calls', show: this.checkPermission('calls', 'calls_missedCalls', this.authService) },
          // { name: 'Voice Mail', show: this.checkPermission('calls', 'calls_voicemails', this.authService) },
          // { name: 'Contacts', show: this.checkPermission('calls', 'calls_contacts', this.authService) },
          // { name: 'History', show: this.checkPermission('calls', 'calls_history', this.authService) },
        ],
        show: this.checkPermission('agent', 'agent_calls', this.authService),
      },
      // TODO: undo chat path when feature is done
      // {
      //   name: 'Chats',
      //   url: '/agent/chats',
      //   icon: 'fa-thin fa-message-captions',
      //   opened: false,
      //   show: this.checkPermission('agent', 'agent_dashboard', this.authService),
      // },
      {
        name: 'Stats', 
        opened: false,
        url: this.agentSideNavStatsParentUrl(),
        icon: 'fa-thin fa-square-poll-vertical',
        children: [ 
          {
            name: 'My Calls',
            url: '/agent/stats/summaries/my-calls',
            active: false,
            icon: 'fa-solid fa-phone-volume',
            show: this.checkPermission('agent_statistics', 'agent_statistics_myCalls', this.authService),
          },
          {
            name: 'My Sales',
            url: '/agent/stats/summaries/my-sales',
            active: false,
            icon: 'fa-solid fa-chart-simple',
            show: this.checkPermission('agent_statistics', 'agent_statistics_mySales', this.authService),
          },
          {
            name: 'Leaderboard',
            url: '/agent/stats/leaderboard',
            active: false,
            icon: 'fa-solid fa-ranking-star',
            show: this.checkPermission('agent_statistics', 'agent_statistics_leaderboard', this.authService),
          },
        ],
        show: this.checkPermission('agent', 'agent_statistics', this.authService),
      },
      {
        name: 'Chat',
        opened: false,
        url: this.agentSideNavChatParentUrl(),
        icon: 'fa-thin fa-square-poll-vertical',
        children: [
          {
            name: 'My Chat',
            url: '/agent/chats/live',
            active: false,
            icon: 'fa-solid fa-comments',
            show: this.checkPermission('agent_chat', 'agent_chat_live', this.authService),
          },
          {
            name: 'My Transcripts',
            url: '/agent/chats/transcripts',
            active: false,
            icon: 'fa-solid fa-message',
            show: this.checkPermission('agent_chat', 'agent_chat_myTranscript', this.authService),
          },
        ],
        show: this.checkPermission('agent', 'agent_chat', this.authService),
      },
      {
        name: 'Settings',
        opened: false,
        url: '/agent/settings',
        icon: 'fa-light fa-gear',
        isBottomLink: true,
        show: this.checkPermission('agent_dashboard', 'agent_dashboard_settings', this.authService),
      },
    ];
  }
  
  private agentSideNavStatsParentUrl(): string {
    const canViewMyCalls = this.checkPermission('agent_statistics', 'agent_statistics_myCalls', this.authService);
    const canViewMySales = this.checkPermission('agent_statistics', 'agent_statistics_mySales', this.authService);
const canViewLeaderboard = this.checkPermission('agent_statistics', 'agent_statistics_leaderboard', this.authService);
    let statsUrl = '';

    if (canViewMyCalls) {
      statsUrl = '/agent/stats/summaries/my-calls';
    } else if (canViewMySales) {
      statsUrl = '/agent/stats/summaries/my-sales';
    } else if (canViewLeaderboard) {
      statsUrl = '/agent/stats/leaderboard';
    }
    return statsUrl;
  }

   private agentSideNavChatParentUrl(): string {
    const canViewChatLive = this.checkPermission('agent_chat', 'agent_chat_live', this.authService);
    const canViewChatMyTranscript = this.checkPermission('agent_chat', 'agent_chat_myTranscript', this.authService);

    let statsUrl = '';

    if (canViewChatLive) {
      statsUrl = '/agent/chats/live';
    } else if (canViewChatMyTranscript) {
      statsUrl = '/agent/chats/transcripts';
    } 
    return statsUrl;
  }
  public insightSideNav() {
    // this.isInsight.next(true);
    //* TODO: Permission Work
    this.sideNavs = [
      {
        name: 'Home',
        url: '/supervisor/insight/dashboard',
        icon: 'fa-thin fa-gauge',
        opened: false,

        show: this.checkPermission('insights', 'insights_dashboard', this.authService),
      },
      // {
      //   name: 'Skill',
      //   opened: false,
      //   url: '/agent/insight/campaign-monitor',
      //   icon: 'fa-light fa-monitor-waveform',

      //   show: this.checkPermission('calls', '', this.authService),
      // },
      // {
      //   name: 'Summary',
      //   opened: false,
      //   url: '/supervisor/insight/summaries/call-details',
      //   icon: 'fa-thin fa-square-poll-vertical',
      //   children: summariesReports.map((x) => {
      //     return {
      //       name: x.name,
      //       url: '/supervisor/insight/summaries/' + x.route,
      //       active: false,
      //       icon: x.icon || 'fa-solid fa-comments',
      //       show: true
      //     }
      //   }),
      //   show: true
      // },
      {
        name: 'Monitor',
        opened: false,
        url: '/supervisor/insight/call-monitor',
        icon: 'fa-light fa-desktop',
        show: this.checkPermission('insights', 'insights_monitor_callMonitor', this.authService),
        children: [
          // {
          //   name: 'Status Monitor',
          //   url: '/supervisor/insight/status-monitor',
          //   active: false,
          //   icon: 'fa-solid fa-tv',
          //   show: this.checkPermission('insights_monitor', 'insights_monitor_agentMonitor', this.authService),
          // },
          {
            name: 'Call Monitor',
            url: '/supervisor/insight/call-monitor',
            icon: 'fa-solid fa-desktop',
            show: this.checkPermission('insights', 'insights_monitor_callMonitor', this.authService),
          },
        ],
      },
      {
        name: 'Script',
        opened: false,
        url: '/supervisor/insight/script-summary',
        icon: 'fa-light fa-scroll',
        show: this.checkPermission('insights', 'insights_script_review', this.authService),
        children: [
          {
            name: 'Script Summary',
            url: '/supervisor/insight/script-summary',
            active: false,
            icon: 'fa-solid fa-scroll',
            show: this.checkPermission('insights', 'insights_script_review', this.authService),
          },
        ],
      },
      {
        name: 'Alerts',
        opened: false,
        url: '/supervisor/insight/alert',
        icon: 'fa-light fa-bell',
        show: true,
        children:[]
      },
      // TODO: undo chat path when feature is done
      // {
      //   name: 'Chat',
      //   opened: false,
      //   url: '/agent/insight/chat',
      //   icon: 'fa-thin fa-message-captions',
      //   children: [
      //     {
      //       name: 'Dashboard',
      //       url: '/agent/insight/chat/dashboard',
      //       active: false,
      //       show: this.checkPermission('statistics', 'statistics_calls', this.authService),
      //     },
      //     {
      //       name: 'Transcripts',
      //       url: '/agent/insight/chat/transcripts',
      //       active: false,
      //       show: this.checkPermission('statistics', 'statistics_sales', this.authService),
      //     },
      //     {
      //       name: 'Offline Messages',
      //       url: '/agent/insight/chat/offline-messages',
      //       active: false,
      //       show: this.checkPermission('statistics', 'statistics_leaderboard', this.authService),
      //     },
      //   ],
      //   show: this.checkPermission('statistics', '', this.authService),
      // },
      // {
      //   name: 'Stats',
      //   opened: false,
      //   url: '/supervisor/insight/calls',
      //   icon: 'fa-thin fa-square-poll-vertical',
      //   children: [
      //     // {
      //     //   name: 'Calls and Sales',
      //     //   url: '/agent/stats/calls',
      //     //   active: false,
      //     //   show: this.checkPermission('statistics', 'statistics_calls', this.authService),
      //     // },
      //     // {
      //     //   name: 'Call List',
      //     //   url: '/agent/insight/calls',
      //     //   active: false,
      //     //   show: this.checkPermission('statistics', 'statistics_sales', this.authService),
      //     // },
      //     {
      //       name: 'Call List',
      //       url: '/supervisor/insight/calls',
      //       active: false,
      //       icon: 'fa-solid fa-phone-volume',
      //       show: this.checkPermission('insights_statistics', 'insights_statistics_callList', this.authService),
      //     },
      //     {
      //       name: 'Daily Summary',
      //       url: '/supervisor/insight/calls/call-activities',
      //       active: false,
      //       icon: 'fa-solid fa-chart-area',
      //       show: this.checkPermission('insights_statistics', 'insights_statistics_callActivities', this.authService),
      //     },
      //     {
      //       name: 'Campaign Summary',
      //       url: '/supervisor/insight/stats/campaign-summary',
      //       active: false,
      //       icon: 'fa-solid fa-chart-simple',
      //       show: this.checkPermission('insights_statistics', 'insights_statistics_campaignSummary', this.authService),
      //     },
      //     {
      //       name: 'Sales List',
      //       url: '/supervisor/insight/stats/sales',
      //       active: false,
      //       icon: 'fa-solid fa-hand-holding-dollar',
      //       show: this.checkPermission('insights_statistics', 'insights_statistics_saleList', this.authService),
      //     },
      //     {
      //       name: 'TFN Summary',
      //       url: '/supervisor/insight/stats/tfn-summary',
      //       active: false,
      //       icon: 'fa-solid fa-hashtag',
      //       show: this.checkPermission('insights_statistics', 'insights_statistics_tfnSummary', this.authService),
      //     },
      //     {
      //       name: 'User Activity',
      //       url: '/supervisor/insight/stats/status-summary',
      //       active: false,
      //       icon: 'fa-solid fa-users-line',
      //       show: this.checkPermission('insights_statistics', 'insights_statistics_statusSummary', this.authService),
      //     },
      //   ],
      //   show: this.checkPermission('insights', 'insights_statistics', this.authService),
      // },
      // {
      //   name: 'Stats',
      //   opened: false,
      //   url: '/supervisor/insight/summaries/call-details',
      //   icon: 'fa-thin fa-square-poll-vertical',
      //   show: this.checkPermission('summaries', '', this.authService),
      //   children: summariesReports.map((x) => {
      //     return {
      //       name: x.name,
      //       url: '/supervisor/insight/summaries/' + x.route,
      //       active: false,
      //       icon: x.icon || 'fa-solid fa-comments',
      //       show: this.checkPermission('summaries', x.route, this.authService),
      //       //beta: true,
      //     };
      //   }),
      // }, 
      {
        name: 'Stats',
        opened: false,
        url: '/supervisor/insight/summaries/call-details',
        icon: 'fa-thin fa-square-poll-vertical',
        show: this.checkPermission('summaries', '', this.authService),
        children: [
          ...summariesReports.map((x) => ({
            name: x.name,
            url: '/supervisor/insight/summaries/' + x.route,
            active: false,
            icon: x.icon || 'fa-solid fa-comments',
            show: this.checkPermission('summaries', x.route, this.authService),
            // beta: true,
          })),
        ],
      },
      {
        name: 'Quality',
        opened: false,
        url: Constants.Apps.QA.defaultPath,
        icon: 'fa-light fa-check',
        show: this.checkPermission('QA', '', this.authService),
        children: [
          {
            name: 'Recording',
            url: '/supervisor/insight/agent-call-evaluation/call-list',
            icon: 'fa-solid fa-phone',
            active: false,
            show: this.checkPermission('quality_recording_list', '', this.authService),
          },
          {
            name: 'Evaluation',
            url: '/QA/evaluation/view-evaluation-list',
            icon: 'fa-solid fa-eye',
            show: this.checkPermission('quality_evaluation_list', '', this.authService),
          },
          {
            name: 'Evaluation',
            url: '/supervisor/insight/agent-call-evaluation/view-submitted-evaluation-list',
            icon: 'fa-solid fa-eye',
            show: this.checkPermission('quality_evaluation_list_sup', '', this.authService),
          },
          {
            name: 'Voicemail',
            url: '/supervisor/insight/agent-call-evaluation/voicemail',
            active: false,
            icon: 'fa-solid fa-voicemail',
            show: this.checkPermission('quality_voicemail_list', '', this.authService),
          },
        ],
      },
      {
        name: 'Leads',
        opened: false,
        url: '/supervisor/insight/leads/list',
        icon: 'fa-light fa-address-book',
        show: this.checkPermission('insights_leads', 'insights_leads_list', this.authService),
        children: [
          {
            name: 'List',
            url: '/supervisor/insight/leads/list',
            icon: 'fa-solid fa-list',
            active: false,
            show: this.checkPermission('insights_leads', 'insights_leads_list', this.authService),
          },
        ],
      },
      {
        name: 'Chat',
        opened: false,
        url: this.insightSideNavChatParentUrl(), // '/supervisor/insight/chat/transcripts',
        icon: 'fa-light fa-chart-pie',
        show: this.checkPermission('insights', 'insights_chat', this.authService),
        children: [
          {
            name: 'Chat Dashboard',
            url: '/supervisor/insight/chat/dashboard',
            icon: 'fa-light fa-chart-pie',
            active: false,
            show: this.checkPermission('insights_chat', 'insights_chat_dashboard', this.authService),
          },
          {
            name: 'Transcripts',
            url: '/supervisor/insight/chat/transcripts',
            icon: 'fa-solid fa-message',
            show: this.checkPermission('insights_chat', 'insights_chat_transcript', this.authService),
          },
          {
            name: 'Offline Messages',
            url: '/supervisor/insight/chat/offline-messages',
            icon: 'fa-solid fa-envelope',
            show: this.checkPermission('insights_chat', 'insights_chat_offlineMessages', this.authService),
          },
        ],
      },
      {
        name: 'VOC',
        opened: false,
        url: '/supervisor/insight/voc/dashboard',
        icon: 'fa-light fa-line-chart',
        show: this.checkPermission('insights_voc', 'insights_voc_dashboard', this.authService),
        children: [
          {
            name: 'VOC Dashboard',
            url: '/supervisor/insight/voc/dashboard',
            active: false,
            icon: 'fa-solid fa-chart-line',
            show: this.checkPermission('insights_voc', 'insights_voc_dashboard', this.authService),
          },
        ],
      },
      {
        name: 'Outbound',
        opened: false,
        url: '/supervisor/insight/outbound-dashboard',
        icon: 'fa-light fa-line-chart',
        show: this.checkPermission('insights_outbound', 'insights_outbound_dashboard', this.authService),
        children: [
          {
            name: 'Outbound Dashboard',
            url: '/supervisor/insight/outbound-dashboard',
            active: false,
            icon: 'fa-solid fa-chart-line',
            show: this.checkPermission('insights_outbound', 'insights_outbound_dashboard', this.authService),
          },
        ],
      },
      {
        name: 'Settings',
        opened: false,
        url: '/supervisor/insight/settings',
        icon: 'fa-light fa-gear',
        isBottomLink: true,
        show: this.checkPermission('insights_dashboard', 'insights_dashboard_settings', this.authService),
      },
      {
        name: 'Contacts',
        opened: false,
        url: '/supervisor/insight/contacts',
        icon: 'fa-light fa-users',
        show: this.checkPermission('calls', '', this.authService),
      },
    ];
  }

  private insightSideNavChatParentUrl(): string {
    const canViewChatDashboard = this.checkPermission('insights_chat', 'insights_chat_dashboard', this.authService);
    const canViewChatTranscript = this.checkPermission('insights_chat', 'insights_chat_transcript', this.authService);
    const canViewOfflineMessages = this.checkPermission('insights_chat', 'insights_chat_offlineMessages', this.authService);

    let url = '';

    if (canViewChatDashboard) {
      url = '/supervisor/insight/chat/dashboard';
    } else if (canViewChatTranscript) {
      url = '/supervisor/insight/chat/transcripts';
    } else if (canViewOfflineMessages) {
      url = '/supervisor/insight/chat/offline-messages';
    } 
    return url;
  }
  public adminSideNav() {
    this.sideNavs = [
      // {
      //   name: 'Home',
      //   url: Constants.Apps.Admin.defaultPath,
      //   icon: 'fa-thin fa-gauge',
      //   opened: false,
      //   show: this.checkPermission('admin', '', this.authService),
      // },
      // {
      //   name: 'Recording',
      //   opened: false,
      //   url: '/admin/callrecording',
      //   icon: 'fa-light fa-desktop',
      //   show: this.checkPermission('admin', 'admin_recordings_call-recording', this.authService),
      //   children: [
      //     {
      //       name: 'Call Recording',
      //       url: '/admin/callrecording',
      //       icon: 'fa-solid fa-record-vinyl',
      //       show: this.checkPermission('admin', 'admin_recordings_call-recording', this.authService),
      //     },
      //     {
      //       name: 'Voicemail',
      //       url: '/admin/voicemail',
      //       active: false,
      //       icon: 'fa-solid fa-voicemail',
      //       show: this.checkPermission('admin', 'admin_recordings_voice-mail', this.authService),
      //     },
      //   ],
      // },
      {
        name: 'Users',
        url: '/admin/user/list',
        icon: 'fa-thin fa-users',
        opened: false, 
        show: this.checkPermission('admin', 'admin_users_list', this.authService),
        children: [
          {
            name: 'User List',
            url: '/admin/user/list',
            icon: 'fa-thin fa-users',
            opened: false,
            show: this.checkPermission('admin', 'admin_users_list', this.authService),
          },
          // {
          //   name: 'Create',
          //   url: '/admin/user/create',
          //   icon: 'fa-thin fa-gauge',
          //   opened: false,
          //   show: this.checkPermission('admin', 'admin_user_create', this.authService),
          // },
        ],
      },
      {
        name: 'TFN',
        opened: false,
        url: '/admin/tfn/list',
        icon: 'fa-solid fa-tty',
        show: this.checkPermission('admin', 'admin_tfn', this.authService),
        children: [
          {
            name: 'TFN List',
            url: '/admin/tfn/list',
            icon: 'fa-solid fa-tty-answer',
            show: this.checkPermission('admin', 'admin_tfn_list', this.authService),
          },
          {
            name: 'Create TFN',
            url: '/admin/tfn/create',
            active: false,
            icon: 'fa-solid fa-phone-plus',
            show: this.checkPermission('admin', 'admin_tfn_create', this.authService),
          },
        ],
      },
      {
        name: 'Campaign',
        opened: false,
        url: '/admin/campaign/list',
        icon: 'fa-solid fa-bullhorn',
        show: this.checkPermission('admin', 'admin_campaign', this.authService),
        children: [
          {
            name: 'Campaign List',
            url: '/admin/campaign/list',
            icon: 'fa-solid fa-bullhorn',
            show: this.checkPermission('admin', 'admin_campaign_list', this.authService),
          },
          {
            name: 'Create Campaign',
            url: '/admin/campaign/create',
            active: false,
            icon: 'fa-solid fa-plus',
            show: false, // this.checkPermission('admin', 'admin_campaign_create', this.authService),
          },
        ],
      },
      // {
      //   name: 'Settings',
      //   opened: false,
      //   url: '/supervisor/insight/settings',
      //   icon: 'fa-light fa-gear',
      //   isBottomLink: true,
      //   show: this.checkPermission('insights_dashboard', 'insights_dashboard_settings', this.authService),
      // },

      {
        name: 'Settings',
        opened: false,
        url: '/admin/settings',
        icon: 'fa-light fa-gear',
        isBottomLink: true,
        show: this.checkPermission('admin', 'admin', this.authService),
      },
    ];
  }
  public QAsideNav() {
    this.sideNavs = [
      {
        name: 'Quality',
        opened: false,
        url: '/QA/evaluation/call-list',
        icon: 'fa-solid fa-check',
        show: this.checkPermission('quality', 'quality_recording_list', this.authService),
        children: [
          {
            name: 'Recording',
            url: '/QA/evaluation/call-list',
            icon: 'fa-solid fa-phone',
            active: false,
            show: this.checkPermission('quality', 'quality_recording_list', this.authService),
          },
          {
            name: 'Evaluation',
            url: '/QA/evaluation/view-evaluation-list',
            icon: 'fa-solid fa-eye',
            show: this.checkPermission('quality', 'quality_evaluation_list', this.authService),
          },
        ],
      },
    ];
  }
  public setCurrentRoute(_route: string): void {
    this.currentRoute = _route;
  }
  public getCurrentRoute(): string {
    return this.currentRoute;
  }
  public setCallContext(_callContext: boolean): void {
    this.callContext = _callContext;
  }
  public getCallContext(): boolean {
    return this.callContext;
  }
  public setProfileContext(_profileContext: boolean): void {
    this.profileContext = _profileContext;
  }
  public getProfileContext(): boolean {
    return this.profileContext;
  }
  public setTitle(_title: string): void {
    this.title = _title;
  }
  public getTitle(): string {
    return this.title;
  }
  public setSideNav(state: boolean, nav = 'left'): void {
    (this as any)[SideNavMapping[nav]] = state;
  }
  public getSideNav(nav = 'left'): boolean {
    return (this as any)[SideNavMapping[nav]];
  }
  public setRightSideRoute(route: _RightSideNavRoutes): void {
    this.rightSideRoute = route;
  }
  public setTranscriptDetailTab(route: _TranscriptDetailTab): void {
    this.transcriptDetailTab = route;
  }
  public getRightSideRoute(): _RightSideNavRoutes {
    return this.rightSideRoute;
  }
  public getTranscriptDetailTab(): _TranscriptDetailTab {
    return this.transcriptDetailTab;
  }
  public setDialScreenText(text: string): void {
    this.dialScreenText += text;
  }
  public removeDialScreenText() {
    this.dialScreenText = this.dialScreenText.replace(/.$/, '');
  }
  public setNotificationAsRead() {
    this.unreadNotificationCount = 0;
  }
  public setUnreadNotificationCount(count = 1) {
    this.unreadNotificationCount += count;
  }
  public getNotificationPane(): boolean {
    return this.notificationPane;
  }
  public toggleNotificationPane() {
    !this.notificationPane && this.closeAllModalsOfTopNav();
    this.notificationPane = !this.notificationPane;

    if (this.notificationPane) this.setNotificationAsRead();
  }

  public toggleRequestPane() {
    !this.requestPane && this.closeAllModalsOfTopNav();
    this.requestPane = !this.requestPane;
  }
  public getRequestPane(): boolean {
    return this.requestPane;
  }
  public getBugReportPane(): boolean {
    return this.bugReportPane;
  }
  public toggleBugReportPane() {
    !this.bugReportPane && this.closeAllModalsOfTopNav();
    this.bugReportPane = !this.bugReportPane;
  }
  private canSplit(str: string, token: string) {
    return (str || '').split(token).length > 1;
  }

  /**
   * getSelectedTab
   * @param tabId     selected tab id
   */
  public getSelectedTab(tabId: number | string) {
    this.selectedTab = tabId as InsightsDashboardTab;
    this.InsightsDashboardTabChange.next(true);
  }

  /**
   * isActiveTab
   * @param tabId        selected tab id
   *
   * @return {boolean}   return true if tab is active
   */
  public isActiveTab(tabId: InsightsDashboardTab) {
    return this.selectedTab === tabId;
  }

  /**
   * toggleRightDrawer
   */
  public toggleRightDrawer() {
    !this.isShowRightDrawer && this.closeAllModalsOfTopNav();
    this.isShowRightDrawer = !this.isShowRightDrawer;
  }
  public toggleLocationDrawer() {
    !this.showCenterLocation && this.closeAllModalsOfTopNav();
    this.showCenterLocation = !this.showCenterLocation; 
  }
  public toggleGridSettingDrawer() {
    !this.showGridSettings && this.closeAllModalsOfTopNav();
    this.showGridSettings = !this.showGridSettings; 
  }

  toggleTimeZoneModal() {
    !this.isTimeZoneModalOpen && this.closeAllModalsOfTopNav();
    this.isTimeZoneModalOpen = !this.isTimeZoneModalOpen;
  }

  closeAllModalsOfTopNav() {
    this.bugReportPane = false;
    this.notificationPane = false;
    this.requestPane = false;
    this.isShowRightDrawer = false;
    this.isTimeZoneModalOpen = false;
    this.showGridSettings = false;
    //* Close User Modal id opened
    this.userService.campaignUpdateModal.isModalOpen && this.userService.closeCampaignUpdateModal();
  }

  public setGridSettings(key: string, settings: any) {
    localStorage.setItem(key, JSON.stringify(settings));
    const url = `/datagrid/settings`;
    const payload = {
      id:"",
      name:"Grid Settings",
      module: key,
      settings:settings
    }
    return this.userService.httpClient.post(url, payload).subscribe({
      next: (res) => {
        this.userService.toastService.success('Grid settings saved successfully');
      },
      error: (err) => {
        console.error('Error saving grid settings:', err);
      }
    });
  }
  
  // public getGridSettings(key: string) {
  //   const settings = JSON.parse(localStorage.getItem(key) || '[]');
  //   if (settings.length > 0) return settings;
  //   const url = `/datagrid/settings?module=${key}`;
  //   return this.userService.httpClient.disableLoader().get(url).subscribe({
  //     next: (res: any) => {
  //       if (res && res.settings) {
  //         localStorage.setItem(key, JSON.stringify(res.settings));
  //         return res.settings;
  //       } else {
  //         return [];
  //       }
  //     },
  //     error: (err) => {
  //       console.error('Error saving grid settings:', err);
  //     }
  //   });
  // }

  public getGridSettings(key: string) {
  const settings = JSON.parse(localStorage.getItem(key) || '[]');

  // Return observable from localStorage
  if (settings.length > 0) {
    return of(settings);
  }

  const url = `/datagrid/settings?module=${key}`;

  return this.userService.httpClient
    .disableLoader()
    .get(url)
    .pipe(
      map((res: any) => {
        if (res && res.settings) {
          const mappedSettings = this.mapGridSettings(res?.settings || []);
          localStorage.setItem(key, JSON.stringify(mappedSettings));
          return mappedSettings;
        }

        return [];
      }),
      catchError((err) => {
        console.error('Error getting grid settings:', err);
        return of([]);
      })
    );
}

private mapGridSettings(settings: any[]) {
  return settings.map((item: any) => ({
    name: item.Name,
    key: item.Key,
    type: item.Type,
    component: item.Component,
    display: item.Display,
    frozen: item.Frozen,
    viewable: item.Viewable,
    listMode: item.ListMode,
    sortable: item.Sortable,
    searchable: item.Searchable,
    searchField: item.SearchField,
    searchFieldOperator: item.SearchFieldOperator,
    width: item.Width,
    left: item.Left
  }));
}

  public getScheduleCallBack() {
    const startDate = moment().startOf('day').toISOString();
    const endDate = moment().endOf('day').toISOString();
    const payload = {
      "Type": "Callback",
      "Sightline": {
        "StartDate": startDate,
        "EndDate": endDate,
        "Fields": "",
        "FieldValues": "",
        "Criteria": "",
        "Limit": 50,
        "Skip": 0,
        "AdvFilters": [],
        "SearchMeta": [],
        "SortMeta": {
          "order": -1,
          "field": "CreatedOn"
        }
      }
    }
    let url = `/summaries/agentList`;
    return this.userService.httpClient.disableLoader().post(url, payload);
  }
}
